var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailgreyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16353 13.6673C1.71449 13.6673 1.33442 13.5118 1.02331 13.2007C0.712196 12.8895 0.556641 12.5095 0.556641 12.0604V1.94087C0.556641 1.49184 0.712196 1.11176 1.02331 0.800651C1.33442 0.48954 1.71449 0.333984 2.16353 0.333984H15.8386C16.2877 0.333984 16.6678 0.48954 16.9789 0.800651C17.29 1.11176 17.4455 1.49184 17.4455 1.94087V12.0604C17.4455 12.5095 17.29 12.8895 16.9789 13.2007C16.6678 13.5118 16.2877 13.6673 15.8386 13.6673H2.16353ZM16.1122 2.94932L9.43353 7.22465C9.36523 7.26332 9.29457 7.29376 9.22153 7.31598C9.14864 7.33821 9.07516 7.34932 9.00109 7.34932C8.92701 7.34932 8.85353 7.33821 8.78064 7.31598C8.7076 7.29376 8.63694 7.26332 8.56864 7.22465L1.88997 2.94932V12.0604C1.88997 12.1403 1.9156 12.2058 1.96686 12.2571C2.01812 12.3084 2.08368 12.334 2.16353 12.334H15.8386C15.9185 12.334 15.984 12.3084 16.0353 12.2571C16.0866 12.2058 16.1122 12.1403 16.1122 12.0604V2.94932ZM9.00109 6.11176L15.9755 1.66732H2.02664L9.00109 6.11176ZM1.88997 3.15443V2.13821V2.16465V2.13643V3.15443Z",
    fill: "#5F6368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailgreyicon);
export default __webpack_public_path__ + "static/media/mail grey icon.cc5466d887622c203c3eb0f28e1e4fc4.svg";
export { ForwardRef as ReactComponent };